export type Testimonial = {
  quote: string
  name: string
  role: string
  location: string
}

export const testimonials: Testimonial[] = [
  {
    quote:
      'Instead of spending my evening rebuilding another Barre class, I can open the system, choose the focus I need and already have a complete structure to work from.',
    name: 'Emily Carter',
    role: 'Barre Instructor',
    location: 'Austin, USA',
  },
  {
    quote:
      'The visual breakdowns are what make the difference. I can quickly see the positioning, progression and modifications without reading pages of theory.',
    name: 'Sophie Martin',
    role: 'Boutique Fitness Instructor',
    location: 'London, UK',
  },
  {
    quote:
      'Having beginner classes, lower-body work, core, upper body, cardio and progressive programming organized in one place makes weekly planning much easier.',
    name: 'Lauren Mitchell',
    role: 'Barre Teacher',
    location: 'Sydney, Australia',
  },
]
